import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Video } from 'icons';

import SegmentActionButton from './SegmentActionButton';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Icon = styled<any>(Video).attrs(({ theme }) => ({
  primaryColor: theme.colors.primary,
  width: 80,
  height: 66,
}))``;

const WatchButton = () => {
  const { t: translate } = useTranslation('courses');

  return (
    <SegmentActionButton text={translate('segment.watch_button.text')}>
      <Icon />
    </SegmentActionButton>
  );
};

export default WatchButton;
